import React, { Component } from 'react'
import { bool, string } from 'prop-types'
import classnames from 'classnames'

import Container from 'components/atoms/Container'
import { SVGIcon } from 'components/qstrap'

import isDOMAvailable from 'utils/isDOMAvailable'

class StickyBackLink extends Component {
  state = {
    sticky: false,
    breadcrumbHeight: 0,
  }

  componentDidMount() {
    if (isDOMAvailable) {
      window.addEventListener('scroll', this.toggleSticky)
      this.setState({
        breadcrumbHeight: document.querySelector('.Breadcrumb').offsetHeight,
      })
    }
  }

  toggleSticky = () => {
    const { sticky, breadcrumbHeight } = this.state

    if (window.scrollY >= breadcrumbHeight) {
      !sticky && this.setState({ sticky: true })
    } else {
      sticky && this.setState({ sticky: false })
    }
  }

  render() {
    const { sticky } = this.state
    const { fixedNavbar, navbarHeight, text, url } = this.props

    const classNameVal = classnames('sticky-back-link', {
      'sticky-back-link--sticky': sticky,
    })
    return (
      <div className={classNameVal}>
        <Container>
          <a href={url}>
            <SVGIcon className="sticky-back-link__icon" name="back" size="md" />
            <span className="sticky-back-link__text">{text}</span>
          </a>
        </Container>
        <style jsx>
          {`
            .sticky-back-link {
              width: 100%;
              background: #fff;
              padding: 20px 0;
              box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
              a {
                display: flex;
                align-items: center;
                &:hover {
                  text-decoration: none;
                }
              }
              :global(&__icon) {
                color: #1e3f6b;
              }
              &__text {
                color: #1e3f6b;
              }
              &.sticky-back-link--sticky {
                position: fixed;
                z-index: 2;
                top: ${fixedNavbar ? `${navbarHeight - 1}px` : 0}
              }
            }
          `}
        </style>
      </div>
    )
  }
}

StickyBackLink.propTypes = {
  text: string,
  url: string,
  navbarHeight: string,
  fixedNavbar: bool,
}

export default StickyBackLink
